import { useState, useEffect } from 'react';

/**
 * Determines if this component is rendering client-side and if native `window`
 * browser objects are accessible. When rendering server-side, this will always
 * return `false`. When rendering client-side, this returns `false` initially
 * and then `true` after the first render cycle completes.
 *
 * This is useful when a component depends on a state field that is only
 * available on the client and causes a SSR/CSR mismatch render warning to
 * occur. This hook will trigger a re-render after the initial render cycle.
 *
 * @example
 * ```tsx
 * const isClient = useIsDocumentReady();
 * return (
 *   {isClient ? <ClientOnlyComponent /> : <Loading />}
 * );
 * ```
 */
export default function useIsDocumentReady() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(typeof window !== 'undefined');
  }, []);

  return isReady;
}
